/* eslint-disable */

import { makeStyles } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Delete, Visibility } from "@material-ui/icons";
import Edit from "@material-ui/icons/Edit";
import Search from "@material-ui/icons/Search";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import TablePaginate from "components/TablePaginate/TablePaginate";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { discordTokenService } from "services/discordTokenService";
import { chains } from "views/Bridge/BridgeIndex";

const FE_LINK = process.env.REACT_APP_FE_LINK;

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

export default function DiscordTokenIndex() {
  const classes = useStyles();
  const [size] = React.useState(10);
  const [open, setOpen] = useState(false);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [isRefresh, setIsRefresh] = useState(false);
  const handleOpen = useCallback(() => setOpen(true), []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Chain ID",
        accessor: "chainId",
        Cell: ({ cell }) => {
          return <p>{chains[cell.row.original.chainId]}</p>;
        },
      },
      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return (
            <>
              <Action cell={cell} setItems={setItems} onCloseModal={handleClose}></Action>
            </>
          );
        },
      },
    ],
    [handleClose, open],
  );

  async function fetchCollections() {
    const payload = {
      search,
      page,
      size,
      sortBy: "order",
      sortType: "asc",
    };
    try {
      const { data } = await discordTokenService.list(payload);
      setItems(data.items);
      setCount(data.paginate.count);
      setPage(data.paginate.page);
      setIsRefresh(false);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    fetchCollections();
  }, [page, search]);

  return (
    <div>
      {confirm}
      <Link to="/admin/discord-token-edit">
        <Button color="info">Add new token</Button>
      </Link>

      <div className={classes.filter}>
        <CustomInput
          labelText="Search"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}

function Action({ cell, onCloseModal, setItems }) {
  const [openDialogDel, setOpenDialogDel] = React.useState(false);

  const handleOpenDel = () => {
    setOpenDialogDel(true);
  };

  const handleCloseDel = () => {
    setOpenDialogDel(false);
  };

  const handleDelete = async (id) => {
    await discordTokenService.remove(id);
    setItems((prev) => prev.filter((item) => item._id !== id));
    handleCloseDel();
  };

  return (
    <div className="actions-right">
      <Button
        justIcon
        round
        simple
        color="warning"
        className="edit"
        onClick={() => handleOpenDel()}
      >
        <Delete />
      </Button>

      <Dialog
        open={openDialogDel}
        onClose={handleCloseDel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm remove token"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDel} color="transparent">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(cell.row.original._id);
            }}
            color="success"
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      <Link to={"/admin/discord-token-edit/" + cell.row.original._id}>
        <Button justIcon round simple color="primary" className="edit">
          <Edit />
        </Button>
      </Link>
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  onCloseModal: PropTypes.any,
};

function View({ cell }) {
  return (
    <div className="actions-right">
      <Link to={"/admin/discord-token/" + cell.row.original.id}>
        <Button justIcon round simple color="success" className="edit">
          <Visibility />
        </Button>
      </Link>
    </div>
  );
}

View.propTypes = {
  cell: PropTypes.any,
};
